<template>
  <v-card rounded="lg" class="h-full d-flex flex-column">
    <div>
      <v-img
        :src="organization.cover"
        height="90"
        class="grey lighten-2 rounded-t-lg"
      />
    </div>
    <div class="pa-4 d-flex flex-column gap-3 flex-grow-1">
      <div class="d-flex align-center gap-3">
        <base-avatar
          :src="organization.photo"
          :size="50"
          :seed="organization?.id"
          avatarStyle="shapes"
        />
        <div>
          <span class="text-overline lh-1">
            {{ organization.Platform.name }}
          </span>
          <h5 class="mb-0 lh-4">{{ organization.name }}</h5>
          <span class="text-caption">
            {{ organization.phone }} • {{ organization.email }}
          </span>
        </div>
      </div>
      <!-- <p class="text-caption mb-0">
        {{ organization._count.Party }} evento{{
          organization._count.Party > 1 ? "s" : ""
        }}
      </p>
      {{ organization }} -->

      <v-card
        v-if="organization.CommercialResponsible"
        outlined
        elevation="0"
        class="pa-3"
        rounded="lg"
      >
        <div class="d-flex gap-3 align-center">
          <base-avatar
            :src="organization.CommercialResponsible.photo"
            :seed="organization.CommercialResponsible.id"
            :size="50"
          />
          <div class="d-flex flex-column">
            <small
              class="text-overline lh-1"
              style="opacity: 0.9; font-size: 10px !important"
            >
              Responsável comercial
            </small>
            <b class="text-14">
              {{ organization.CommercialResponsible.name }}
            </b>
            <small>{{ organization.CommercialResponsible.phone }}</small>
          </div>
        </div>
      </v-card>
      <v-card v-else outlined elevation="0" class="pa-3" rounded="lg">
        <div class="d-flex align-center gap-3">
          <v-icon size="40">mdi-account-question</v-icon>
          <div class="d-flex flex-column">
            <h6 class="mb-0">Nenhum responsável comercial</h6>
            <!-- <span>
              Adicione um responsável comercial para gerenciar as partidas
            </span> -->
          </div>
        </div>
      </v-card>
    </div>
    <div class="pa-4 pt-0">
      <v-btn color="primary" block depressed @click="handleManageOrganization">
        Gerenciar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    organization: Object,
  },
  methods: {
    handleManageOrganization() {
      this.$router.push(`/admin/organization/${this.organization.id}`);
    },
  },
};
</script>
